import React from 'react';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { Calendar } from 'primereact/calendar';

interface ChangeTaxFillingDateModalProps {
    visible: boolean;
    onHide: () => void;
    onConfirm: () => void;
    loading: boolean;
    value: Date[];
    onChange: (e: any) => void;
    errors?: any;
    minDate?: Date;
    header?: string;
}

const ChangeTaxFillingDateModal = ({
    visible,
    onHide,
    onConfirm,
    loading,
    value,
    onChange,
    errors,
    minDate,
    header = "Select Tax Filing Date"
}: ChangeTaxFillingDateModalProps) => {
    return (
        <Dialog
            visible={visible}
            style={{ width: '450px' }}
            header={header}
            draggable={false}
            className="mx-3 lg:mx-0"
            modal
            footer={
                <>
                    <Button
                        label="Cancel"
                        icon="pi pi-times"
                        className="p-button-secondary"
                        onClick={onHide}
                    />
                    <Button
                        label="Confirm"
                        icon="pi pi-check"
                        className="common-primary-button"
                        onClick={onConfirm}
                        loading={loading}
                    />
                </>
            }
            onHide={onHide}
        >
            <div className="">
                <div className="grid p-fluid formgrid">
                    <div className="field col-12 ">
                        <label htmlFor="status">
                            Select Date <span className="required">*</span>
                        </label>
                        <Calendar
                            value={value}
                            onChange={onChange}
                            readOnlyInput
                            dateFormat="dd/mm/yy"
                            placeholder="Select Date"
                            minDate={minDate}
                            showIcon
                            selectionMode="multiple"
                        />
                        {errors?.date && <small className="p-invalid-txt">{errors.date}</small>}
                    </div>
                </div>
            </div>
        </Dialog>
    );
};

export default ChangeTaxFillingDateModal;